import { appPostStructuredMessage } from '@common/utils/appUtils';
import AccordionComponent from './accordionComponent';
export default class FaqComponent extends AccordionComponent {
    constructor(element) {
        super(element);
        this.initAccordion();
    }
    toggleAccordion(e, el) {
        var _a;
        e.preventDefault();
        if (el.getAttribute(this.ATTRIBUTES.isExpanded) == 'true') {
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'false');
        }
        else {
            const dataAnalytics = el.getAttribute('data-analytics');
            if (dataAnalytics) {
                (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(JSON.parse(dataAnalytics));
            }
            this.accordionHeaders.forEach((el) => el.setAttribute(this.ATTRIBUTES.isExpanded, 'false'));
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'true');
            const target = e.currentTarget;
            let sectionTitle = target.closest('div.faq-component').id.replaceAll('-', '_');
            if (window.appmode) {
                appPostStructuredMessage('firebase_analytics', {
                    event: 'client_service_interactions',
                    params: {
                        Action: 'client_service-faq-' + sectionTitle,
                        pageDetail: 'clientservice',
                    },
                });
            }
        }
    }
}
